var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","appear":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],attrs:{"id":"officeonline-wrapper"}},[_c('iframe',{ref:"documentFrame",attrs:{"id":"officeonlineframe","src":_vm.src}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }